import React, { FC } from 'react';
import styles from './audioRecordingBadge.module.scss';
import classNames from 'classnames/bind';

import Colors from '@domain/constant/colors';
import Icon from '@components/common/assets';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';

const cx = classNames.bind(styles);

interface Props {
  active?: boolean;
}

export const AudioRecordingBadge: FC<Props> = (props) => {
  const { active } = props;

  return (
    /*
            Q. 왜 축약으로 쓰지 않는지?
            A. Props 변경에 따른 className 변경을 막기 위함입니다.
               {active: active}는 active 변수를 단순히 객체에 담는 것에 중점을 둔 것이 아니라,
               {['active']: active} 와 동일한 의미입니다.
               {active}로 할 경우, 프롭을 변경함에 따라 className이 변경되거나 예상치 못한 버그를 일으킬 수 있습니다.
               장기적으로는 className이 .module.scss 파일에 없으면 안되도록 되어야할 필요가 있어야 할 것 같습니다.
         */
    <div className={cx('badge')}>
      <div className={cx('status')}>
        <Icon width={24} height={24} name="micLight" fill={active ? Colors.C_GREEN_150 : Colors.C_WHITE} />
        <Text fontStyle={FontStyle.B3_M} color={active ? Colors.C_GREEN_150 : Colors.C_WHITE}>
          마이크 작동 중
        </Text>
      </div>
    </div>
  );
};
